// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2n-fX","label":"Section_label__qc5y8","contentWrap":"Section_contentWrap__21jI-","footer":"Section_footer__2-6LC","footerInner":"Section_footerInner__3d6f6"};